// extracted by mini-css-extract-plugin
module.exports = {"color-swatch-size":"30px","swatch":"PlacementOnlyTab_swatch__3sjiH"};